import React, { useRef, useState, useEffect } from 'react';
import ReactModal from 'react-modal';
import { ReactComponent as CloseModalIcon } from '../../../assets/svg/CloseModalIcon.svg';
import { FaCreditCard, FaEdit, FaSubscript, FaTrash, FaUser } from 'react-icons/fa';
import { deleteUser, getSingleUserById, softDeleteUser } from '../../../server/server';
import ChangeSubscriptionModal from './ChangeSubscriptionModal';
import CreateEditUserModal from './CreateEditUserModal';
import { format } from 'date-fns';
import ConfirmationModal from './ConfirmationModal';

function UserProfileModal({ modalIsOpen, closeModal, user = null, reloadList = () => {} }: { modalIsOpen: any; closeModal: any; user: any; reloadList: any }) {
    const [userProfile, setUserProfile] = useState<any>(null);
    const [changeSubscriptionModal, setChangeSubscriptionModal] = useState(false);
    const [createEditUserModal, setCreateEditUserModal] = useState(false);
    const [deleteUserModal, setDeleteUserModal] = useState(false);
    const [deletingUserProcessing, setDeletingUserProcessing] = useState(false);

    const openChangeSubscription = () => {
        setChangeSubscriptionModal(true);
    };

    const closeChangeSubscription = () => {
        setChangeSubscriptionModal(false);
    };

    const openCreateUserModal = (user: any) => {
        setCreateEditUserModal(true);
    };

    const closeCreateUserModal = () => {
        setCreateEditUserModal(false);
    };

    const openDeleteUserModal = () => {
        setDeleteUserModal(true);
    };

    const closeDeleteUserModal = () => {
        setDeleteUserModal(false);
    };

    useEffect(() => {
        if (modalIsOpen && !!user) loadUser();
    }, [modalIsOpen, user]);

    const loadUser = async () => {
        const resp = await getSingleUserById(user?.id);
        if (resp.status === 200) {
            setUserProfile(resp.data);
        }
    };

    const removeUser = async () => {
        setDeletingUserProcessing(true);
        const resp = await softDeleteUser(userProfile?.id);
        if (resp.status === 200) {
            closeDeleteUserModal();
            reloadList();
            closeModal();
            setDeletingUserProcessing(false);
        } else {
            setDeletingUserProcessing(false);
        }
    };

    const reloadChanges = () => {
        loadUser();
        reloadList();
    };

    const cleanUpFunction = () => {
        setUserProfile(null);
    };
    return (
        <ReactModal
            isOpen={modalIsOpen}
            onAfterOpen={() => {}}
            onAfterClose={() => cleanUpFunction()}
            onRequestClose={closeModal}
            style={{
                overlay: {
                    zIndex: 7,
                    background: '#00000045',
                },
                content: {
                    padding: 0,
                    paddingTop: 30,
                    paddingBottom: 30,
                    opacity: 1,
                    width: 600,
                    margin: 'auto',
                    backgroundColor: 'transparent',
                    maxHeight: '100vh',
                    border: '0px',
                    boxShadow: 'none',
                    overflow: 'auto',
                    outlineWidth: 0,
                },
            }}
            className={'no-scroll border-0'}
        >
            <div className="student-info-modal  " style={{ paddingLeft: 20, paddingRight: 20 }}>
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <div className="close-modal-icon " onClick={() => closeModal()}>
                        <CloseModalIcon />
                    </div>
                </div>
                <div className="bg-white rounded-xl mx-3 flex-1 flex flex-col  px-[20px] py-[20px]">
                    <div className="flex flex-row ">
                        <div className="flex flex-row items-center gap-3">
                            <div className="min-w-[60px] h-[60px] rounded-full bg-grey-400 border border-gray600 flex items-center justify-center">
                                <FaUser width={50} height={50} color="white" />
                            </div>
                            <div>
                                <p className="text-gray900 font-semibold text-[16px] leading-5">{userProfile?.username}</p>

                                <p className="text-gray600 font-medium text-[16px] leading-5">{userProfile?.email}</p>
                            </div>
                        </div>
                        {/* <div className='pl-2 cursor-pointer' onClick={() => closeModal()}>
							<CloseModalIcon color='#475467' />
						</div> */}
                    </div>
                    <div className="border-b border-b-gray300 mt-5"></div>
                    <div className="flex flex-row justify-between mt-5">
                        <p className="text-gray600 font-semibold text-[16px] leading-5">Jedinstveni broj</p>
                        <p className="text-gray600 font-medium text-[16px] leading-5">{userProfile?.uniqueNumber}</p>
                    </div>
                    <div className="border-b border-b-gray300 mt-5"></div>
                    <div className="flex flex-row justify-between mt-5">
                        <p className="text-gray600 font-semibold text-[16px] leading-5">Validan</p>
                        <p className="text-gray600 font-medium text-[16px] leading-5">{userProfile?.valid ? 'Validan' : 'Nije validan'}</p>
                    </div>
                    <div className="border-b border-b-gray300 mt-5"></div>
                    <div className="flex flex-row justify-between mt-5">
                        <p className="text-gray600 font-semibold text-[16px] leading-5">Vazenje pretplate</p>
                        <p className="text-gray600 font-medium text-[16px] leading-5">{format(userProfile?.endDate ?? null, 'dd.MMM.yyyy HH:mm')}</p>
                    </div>
                    <div className="border-b border-b-gray300 mt-5"></div>

                    {userProfile?.subscriptions && (
                        <>
                            <div className="flex flex-row justify-between mt-5">
                                <p className="text-gray600 font-semibold text-[16px] leading-5">Pretplata</p>
                                <div className="flex flex-row gap-1">
                                    {userProfile.subscriptions?.map((item: any, index: number) => (
                                        <div className="bg-blue50 flex w-fit rounded-[20px] border border-blue200 px-2 py-[2px]" key={index}>
                                            <p className="text-blue700 font-medium text-[14px] leading-5">{item.subscription.subscription.codeName}</p>
                                        </div>
                                    ))}
                                    {!userProfile?.subscriptions?.length && (
                                        <div className="bg-greyBackground flex w-fit rounded-[20px] border border-greyMedium px-2 py-[2px] cursor-pointer">
                                            <p className="text-greyStrong font-medium text-[14px] leading-5">Nije pretplaćen</p>
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div className="border-b border-b-gray300 mt-5"></div>
                        </>
                    )}
                    <div className="flex flex-row justify-between mt-5">
                        <p className="text-gray600 font-semibold text-[16px] leading-5">Datum kreiranja</p>
                        <p className="text-gray600 font-medium text-[16px] leading-5">
                            {!!userProfile?.createdAt ? format(new Date(userProfile?.createdAt), 'dd.MM.yyyy') : new Date().toDateString()}
                        </p>
                    </div>

                    <div className="border-b border-b-gray300 mt-5"></div>
                    <div className="flex flex-row justify-end gap-3 mt-10">
                        <div
                            className="flex flex-row gap-2 items-center rounded-[6px] bg-[#EEF4FF] border border-[#C7D7FE] hover:border-[#3538CD]  p-[6px] cursor-pointer transition"
                            onClick={() => openChangeSubscription()}
                        >
                            <FaCreditCard width={20} height={20} color="#3538CD" />
                            <p className="text-[#3538CD] font-semibold text-[14px] leading-5">Promeni pretplatu</p>
                        </div>
                        <div
                            className="flex flex-row gap-2 items-center rounded-[6px] bg-[#EEF4FF] border border-[#C7D7FE] hover:border-[#3538CD]  p-[6px] cursor-pointer transition"
                            onClick={() => openCreateUserModal(userProfile)}
                        >
                            <FaEdit width={20} height={20} color="#3538CD" />
                            <p className="text-[#3538CD] font-semibold text-[14px] leading-5">Izmeni profil</p>
                        </div>
                        <div
                            className="flex flex-row gap-2 items-center rounded-[6px] bg-[#EEF4FF] border hover:border-[#3538CD] border-[#C7D7FE]  p-[6px] cursor-pointer transition"
                            onClick={() => openDeleteUserModal()}
                        >
                            <FaTrash width={20} height={20} color="#3538CD" />
                            <p className="text-[#3538CD] font-semibold text-[14px] leading-5">Obriši profil</p>
                        </div>
                    </div>
                </div>
            </div>
            <ChangeSubscriptionModal
                modalIsOpen={changeSubscriptionModal}
                closeModal={closeChangeSubscription}
                user={userProfile}
                reloadList={() => reloadChanges()}
            />
            <CreateEditUserModal
                modalIsOpen={createEditUserModal}
                closeModal={closeCreateUserModal}
                userProfile={userProfile}
                reloadUserUpdate={reloadChanges}
            />
            <ConfirmationModal
                modalIsOpen={deleteUserModal}
                closeModal={closeDeleteUserModal}
                confirmation={removeUser}
                message={'Do you want to delete this user?'}
                subMessage="The user will be permanently deleted."
                processing={deletingUserProcessing}
            />
        </ReactModal>
    );
}

export default UserProfileModal;
